import { useState } from 'react'

import { cn } from '@/lib/utils'

import { Spinner } from './ui/spinner'

interface LazyImageProps {
  src: string
  alt: string
  className?: string
  containerClassName?: string
  aspectRatio?: 'square' | '4/3' | '16/9' | 'auto'
  onLoad?: () => void
  onError?: () => void
}

export const LazyImage = ({ src, alt, className, containerClassName, aspectRatio = 'square', onLoad, onError }: LazyImageProps) => {
  const [isLoading, setIsLoading] = useState(true)
  const [hasError, setHasError] = useState(false)

  const aspectRatioClasses = {
    square: 'aspect-square',
    '4/3': 'aspect-[4/3]',
    '16/9': 'aspect-video',
    auto: 'aspect-auto',
  }

  const handleLoad = () => {
    setIsLoading(false)
    onLoad?.()
  }

  const handleError = () => {
    setIsLoading(false)
    setHasError(true)
    onError?.()
  }

  return (
    <div className={cn('relative overflow-hidden', aspectRatioClasses[aspectRatio], containerClassName)}>
      {isLoading && (
        <div className='absolute inset-0 flex items-center justify-center bg-gray-100'>
          <Spinner className='size-8 text-gray-400' />
        </div>
      )}
      {hasError ? (
        <div className='flex h-full w-full items-center justify-center bg-gray-100 text-sm text-gray-500'>שגיאה בטעינת התמונה</div>
      ) : (
        <img
          src={src}
          alt={alt}
          onLoad={handleLoad}
          onError={handleError}
          loading='lazy'
          className={cn('h-full w-full object-cover transition-opacity duration-300', isLoading ? 'opacity-0' : 'opacity-100', className)}
        />
      )}
    </div>
  )
}
